import React, { useEffect, useState, useRef } from "react";
import styles from "./RelatedCourses.module.css";
import { getAccessToken, getALMConfig } from "../../../utils/global";
import type { CourseTrainingProps } from '../../../utils/courseButtonProps';
import BookmarkSingleOutline from "@spectrum-icons/workflow/BookmarkSingleOutline";
import BookmarkSingle from "@spectrum-icons/workflow/BookmarkSingle";
import {
    PrimeLearningObject,
    PrimeLearningObjectInstance
} from "../../../models/PrimeModels";

export interface ALMObject {
    id: string;
    title: string;
    imageUrl?: string;
    skill: string;
    instance?: string;
    bookMark?: boolean;
}

const RelatedCourses: React.FC<{
    training: PrimeLearningObject;
    courseBtnText?: CourseTrainingProps;
}> = (props: any) => {

    const {training, courseBtnText} = props;
    const [response, setResponse] = useState<ALMObject[]>([]);
    const relatedCourseTitleText = courseBtnText?.relatedCoursesText?.trim() || "Related courses";

    const baseApiUrl = getALMConfig().primeApiURL;

    const fetchCourses = async (url: string) => {
        try {
            const res = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `oauth ${getAccessToken()}`,
                    "Accept": "application/vnd.api+json"
                }
            });

            if (!res.ok) {
                throw new Error(`hTTp error status: ${res.status}`)
            }

            const json = await res.json();

            const includedMap: Record<string, any> = {};
            (json.included || []).forEach((inc: any) => {
                includedMap[inc.id] = inc;
            });
            // Merge data and included
            const data = (json.data || []).map((item: any) => {
                const loId = item.relationships?.learningObject?.data?.id;
                const metaObj = includedMap[loId]?.attributes || {};
                const meta = metaObj.localizedMetadata?.[0] || {};
                const dataItem = item.attributes;
                let skillId = item.relationships.skills.data[0].id;

                if (skillId) {
                    skillId = skillId.split('_')[1];
                }

                return {
                    id: item.id,
                    title: dataItem.localizedMetadata[0].name || "Untitled",
                    imageUrl: dataItem.imageUrl,
                    skill: includedMap[skillId]?.attributes.name,
                    instance: item.relationships.instances.data[0].id,
                    bookMark: dataItem.isBookmarked
                } as ALMObject;
            });

            if (res) {
                setResponse(data);
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    const bookMark = async (id: string, save: boolean) => {
        try {

            const currentUrl = `${baseApiUrl}/learningObjects/${id}/bookmark`;
            const res = await fetch(currentUrl, {
                method: save ? "POST" : "DELETE",
                headers: {
                    "Authorization": `oauth ${getAccessToken()}`,
                    "Accept": "application/vnd.api+json"
                }
            });

        console.log('res', res)

            if (!res.ok) {
                throw new Error(`hTTp error status: ${res.status}`)
            }

            setResponse(response.map(item => item.id === id ? { ...item, bookMark: save} : item));

        } catch (error) {
            console.log('error', error)
        }
    }

    useEffect(() => {
        const currentUrl = `${baseApiUrl}/learningObjects/${training.id}/relatedLOs?limit=3&type=recommendations&include=skills.skillLevel.skill`;
        fetchCourses(currentUrl);
    }, []);

    return (
        response.length > 0 ? <div className={styles.pageContainer}>
            <div className={styles.contentContainer} >
                <div className={styles.sectionTitle}>
                    <h4>{relatedCourseTitleText || "Related courses"}</h4>
                </div>

                <div className={styles.list}>
                    {response?.map((item: any, idx: number) => (
                        <div className={styles.item}>
                            <div className={styles.image}>
                                <img src={item.imageUrl} alt={item.title} />
                            </div>
                            <div className={styles.desc}>
                                <div><a href={`${courseBtnText.detailPagePath}.html/trainingId/${item.id}/trainingInstanceId/${item.instance}`}>{item.title}</a></div>
                                <p>Skills: <b>{item.skill}</b></p>
                                <div className={styles.bookMark}>
                                    {item.bookMark ? <span onClick={() => bookMark(item.id, false)}><BookmarkSingleOutline /></span> : <span onClick={() => bookMark(item.id, true)}><BookmarkSingle /></span>}
                                </div>
                            </div>
                        </div>))}
                </div>
            </div>
        </div> : <></>
    )
};

export default RelatedCourses;
